import { Link } from 'react-router-dom';
import { PRODUCT } from '../config';

export function ComingSoon({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <main className="page">
      <p className="eyebrow">{PRODUCT.name}</p>
      <h1>{title}</h1>
      <p>{children}</p>
      <p><Link to="/">Back</Link></p>
    </main>
  );
}
